import { render } from "./BecomeSeller.vue?vue&type=template&id=ffb50c04&scoped=true"
import script from "./BecomeSeller.vue?vue&type=script&lang=js"
export * from "./BecomeSeller.vue?vue&type=script&lang=js"

import "./BecomeSeller.vue?vue&type=style&index=0&id=ffb50c04&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb50c04"]])

export default __exports__